import { useMemo } from 'react';
import { useGetPermission } from '../useNewPermisson';

export const useHasMercadoChatPermission = () => {
  const getPermission = useGetPermission();

  // 美客多接待权限
  const hasMercadoChatPermission = useMemo(
    () => getPermission('基础聊天权限', { platform: 'MERCADO' }),
    [getPermission],
  );

  return hasMercadoChatPermission;
};
